import React from "react";
import { Helmet } from "react-helmet";

import BannerCorporativeCulture from "components/CorporativeCultureSection/BannerCorporativeCulture";
import CorporativeCultureContent from "components/CorporativeCultureSection/CorporativeCultureContent";
import CorporativeCultureCard from "components/CorporativeCultureSection/CorporativeCultureCard";
import CorporativeCultureBaseboard from "components/CorporativeCultureSection/CorporativeCultureBaseboard";


const CorporativeCulture = () => {
  return (
    <article>
       <Helmet>
          <title> CNP Seguros Holding Brasil | Cultura Corporativa</title>
          <meta name="description" content="Conheça nossa cultura corporativa" />
          <meta name="keywords" content="CNP Seguros, CNP Holding Brasil, DNA, cultura corporativa, valores, essência, missão, propósito, visão" />
      </Helmet>
      <BannerCorporativeCulture />
      <CorporativeCultureContent />
      <CorporativeCultureCard />
      <CorporativeCultureBaseboard/>
    </article>
  );
};

export default CorporativeCulture;
